import { SPONSOR_LETTER } from "../../../Constants/childLetter";

export const GET_SPONSOR_CHILDREN = "get_sponsor_children";
export const GET_SPONSOR_CHILD = "get_sponsor_child";
export const GET_CHILD_PHOTO = "get_child_photo";
export const SELECT_DOC_CODE = "select_doc_code";
export const SET_LOADING = "set_loading";
export const DISABLE_MENU = "disable_menu";
export const VIEW_MESSAGE = "view_message";
export const CLEAR_MESSAGE = "clear_message";
export const SET_SELECTED_MESSAGE = "set_selected_message";
export const SELECT_CHILD = "select_child";

export const docReducer = (state, action) => {
    // console.log({state, action });
    switch (action.type) {
        case SELECT_CHILD:
            // console.log(action);
            return returnState(state, { selectedChildId: action.childId });
        case GET_SPONSOR_CHILDREN:
            return returnState(state, { children: [...action.data] });
        case GET_SPONSOR_CHILD:
            return returnState(state, { child: action.data });
        case GET_CHILD_PHOTO:
            return returnState(state, { selectedChildPhoto: action.data });
        case SELECT_DOC_CODE:
            return returnState(state, { code: action.code });
        case SET_LOADING:
            return returnState(state, { loading: action.isloading });
        case DISABLE_MENU:
            return returnState(state, { menuDisabled: !state.menuDisabled });
        case SET_SELECTED_MESSAGE:
            return returnState(state, { selectedMessage: action.index });
        case VIEW_MESSAGE:
            if (state.code === SPONSOR_LETTER.code) {
                let file = action.data.filter((file, i) => i === action.index);

                let view = {
                    id: action.index,
                    updatedAt: file[0].updated_at,
                    childName: file[0].given_name,
                    message: file[0].message
                };
                return returnState(state, {
                    messageContent: view,
                    selectedMessage: action.index
                });
            } else {
                return returnState(state, { messageContent: {} });
            }
        case CLEAR_MESSAGE:
            return returnState(state, {
                messageContent: {},
                selectedMessage: null
            });
        default:
            return state;
    }
};

function returnState(oldState, newState) {
    return { ...oldState, ...newState };
}
